// extracted by mini-css-extract-plugin
module.exports = {"carouselSlide":"carousel-slide-module--carousel-slide--1l9pi","current":"carousel-slide-module--current--1nQn6"};